import type { PinnedConversation } from 'services/conversations'
import actions from './actions'

/**
 * Holds only what the server confirmed. The draft the admin is editing stays in
 * component state, so `saved` is an unambiguous baseline for the dirty check.
 */
export interface PinnedConversationsState {
  /** Last server-confirmed list, in server order. The dirty-check baseline. */
  saved: PinnedConversation[]
  /** A GET is in flight. */
  loading: boolean
  /** A PUT is in flight — the section disables its controls while true. */
  saving: boolean
  /** Server message from the last failed call; null once a call succeeds. */
  error: string | null
}

const initialState: PinnedConversationsState = {
  saved: [],
  loading: false,
  saving: false,
  error: null,
}

// Only SET_STATE (a partial merge) mutates the slice; the sagas do the work.
interface PinnedConversationsAction {
  type: string
  payload?: Partial<PinnedConversationsState>
}

export default function pinnedConversationsReducer(
  state: PinnedConversationsState = initialState,
  action: PinnedConversationsAction = { type: '' },
): PinnedConversationsState {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
